import { IntlShape } from 'react-intl';
import { messages } from './messages';
import { LocationSchema } from '@fhnw/schemas/location';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.Locations),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['locations'],
    },
  ],
  properties: {
    locations: {
      title: intl.formatMessage(messages.Locations),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: LocationSchema({ intl: intl }),
          },
        },
      },
      default: [],
    },
  },
  required: [],
});

export default Schema;
